import Vue from 'vue'
import Router from 'vue-router'
import index from '../components/index'
import Gg from '../components/Gg'
import xiaoqing from '../components/xiaoqing'
import tangtang from '../components/tangtang'
import zen from '../components/zen'
import test from '../components/test'
import jiaqi from '../components/jiaqi'
import gelei from '../components/gelei'
import meijiezz from '../components/meijiezz'
import xiaobai from '../components/xiaobai'
import sl from '../components/sl'
import test1 from '../components/test1'
import time from '../components/time'
import xiaoqiu from "../components/xiaoqiu"
import demo from "../components/demo"
import bxm from '../components/bxm'
import directpkg from '../components/directpkg'
import woshitangtang from "../components/woshitangtang"
import jiuzhou from "../components/jiuzhou";
import wei from "../components/wei"
import xq from "../components/xq"
import update from "../components/update"
import vivoplsb from "../components/vivoplsb"
import oppo from "../components/oppo"
import zui from "../components/zui"
import oppo1 from "../components/oppo1";
import ScheduledSendToV from "../components/login/ScheduledSendToV";
import zs from "../components/zs"
import fjtuia from "../components/fjtuia";
import index1 from "../components/login/index1";
import tui from "../components/tui";
import tuia2 from "../components/tuia2";
import weimiao from "../components/weimiao";
import vueTestUpdate from "../components/login/vueTestUpdate";
import batchUpdate from "../components/batchUpdate";
import list from "../components/list";
import vueTestUpdateTest from "../components/login/vueTestUpdateTest";
import TestC from "../components/login/TestC";
import SongshuUpdate from "../components/login/SongshuUpdate";
import hudong from "../components/login/hudong";
import kuaiyingy from "../components/login/kuaiyingy";
import batchLogin from "../components/login/batchLogin";
import cesuan from "../components/cesuan";
import haobaobao from "../components/login/haobaobao";
import hbb from "../components/login/hbb";
import addInfoBatch from "../components/login/addInfoBatch";
import talk from "../components/login/talk";
import xiaoshuo1 from "../components/xiaoshuo1";
import OpBatch from "../components/login/OpBatch";
import quickappbiaodan from "../components/login/quickappbiaodan";
import oppobiaodan from "../components/oppo/oppobiaodan";
import BetaOpBatch from "../components/login/BetaOpBatch";
import baijiu from "../components/login/baijiu";
import baijiu1 from "../components/baijiu1";
import oppoupdate from "../components/oppoupdate";
import yidian from "../components/yidian";
import tianqiao from "../components/tianqiao";
import opBatchXS from "../components/login/OpBatchXS";
import manzheng from "../components/manzheng";
import zhihui from "../components/zhihui";
import duanju from "../components/duanju";
import zhangyue from "../components/login/zhangyue";
import suanming from "../components/suanming";
import jycs from "../components/jycs";
import wcaidemo from "../components/wcaidemo";
import geleio from "../components/geleio";
import huanxing from "../components/huanxing";
import batchhx from "../components/login/batchhx";
import szh from "../components/login/szh";
import llks from "../components/login/llks";
import yunshang from "../components/login/yunshang";
import batchmt from "../components/login/batchmt";
import chomo from "../components/login/chomo";
import batchYhk from "../components/login/batchYhk";
import BatchUpdateCode from "../components/batchUpdateCode";
import sucaiku from "../components/login/sucaiku";
import code from "../components/code";
import vivoUserInfo from "../components/VivoUserInfo";
import UpdateOp2 from "../components/UpdateOp2";
import yikai from "../components/login/yikai";
import ywd from "../components/ywd";
import shengmi from "../components/login/shengmi";
import guagua from "../components/login/guagua";
import feimao from "../components/login/feimao";
import dtareafeimao from "../components/login/dtareafeimao";
import qingmu from "../components/login/qingmu";
import zhuishu from "../components/login/zhuishu";
import misu from "../components/login/misu";
import hutao from "../components/login/hutao";
import qiqi from "../components/qiqi";
import batchState from "../components/batchState";
import planStop from "../components/planStop";
import zuikan from "../components/zuikan";
import qjwf from "../components/qjwf";
import Cidcaimac from "../components/cidcaima";
import fengqi from "../components/fengqi";
import sanqibathc from "../components/login/sanqibathc"
import cidbatch from "../components/login/cidbatch";
import peixun from "../components/peixun";
import fxinfanhua from "../components/login/fxinfanhua";
import vivopidaces from "../components/login/vivopidaces";
import newvivopidaces from "../components/vivo/vivopda/index.vue";
import qtttoken from "../components/login/qtttoken";
import OppoCkDashboard from "../components/login/OppoCkDashboard";
import smqudao from "../components/login/smqudao";
// import vquickpida from "../components/login/vquickpida";
// import vquickpidaces from "../components/login/vquickpidaces";
import chpida from "../components/login/chpida";
import oppoAll from "../components/login/oppoAll";
import oppofujianAll from "../components/login/oppofujianAll";
import szAllData from "../components/login/szAllData";
import xindyy from "../components/login/xindyy";
import dyy from "../components/login/dyy";
import cidbb from "../components/cidbb";
import cidgelei from "../components/cidgelei";
import shyb from "../components/shyb";
import oppldjmf from "../components/login/oppldjmf";
import tytest from "../components/tytest";
import volzh from "../components/volzh";
import daiyunying from "../components/daiyunying";
import yachen from "../components/yachen";
import opzhbzf from "../components/opzhbzf";
import fufei01 from "../components/login/fufei01";
import fufei02 from "../components/login/fufei02";
import huomiao from "../components/login/huomiao";
import modou from "../components/login/modou";
import feiyu from "../components/login/feiyu";
import qdx from "../components/login/qdx";
import Ophuanxing from "../components/login/huanxing";
import zjqukan from "../components/zjqukan";
import diyu from "../components/diyu";
import jus from "../components/login/jus";
import huidu from "../components/login/huidu";
import weichiAllData from "../components/login/weichiAllData";
import weichiAllDataNew from "../components/login/weichiAllDataNew";
import fujianAllData from "../components/login/fujianAllData";
import zjAllData from "../components/login/zjAllData";
import DataSourse from "../components/login/DataSourse";
import qdxqdhcj from "../components/login/qdxqdhcj";
import DataSourse1 from "../components/login/DataSourse1";
import DataSourse2 from "../components/login/DataSourse2";
import zhzqian from "../components/login/zhzqian";
import audience from "../components/login/audience";
import statusquery from "../components/login/statusquery"
import yzm from "../components/login/yzm"
import quttzh from "../components/login/quttzh"
import qutotiaopida from "../components/login/qutotiaopida"
import qttdxb from "../components/login/qttdxb"
import selectime from "../components/login/selectime"
import vivoRegistrationList from "../components/kehu/vivoRegistration/vivoRegistrationList.vue"
import opsqf from "../components/kehu/vivoRegistration/opsqf.vue"
import opaike from "../components/kehu/vivoRegistration/opaike.vue"
import vivomanju from "../components/kehu/vivoRegistration/vivomanju.vue"
import vivoyake from "../components/kehu/vivoRegistration/vivoyake.vue"
import vivozy from "../components/kehu/vivoRegistration/vivozy.vue"
import opyabs from "../components/kehu/vivoRegistration/opyaboshi.vue"
import opxly from "../components/kehu/vivoRegistration/opxly.vue"
import csmfqd from "../components/kehu/csmfqd.vue"
import drpkg from "../components/oppo/drpkg.vue"
import getApi from "../components/oppo/getApi.vue"
// import dingshi from "../components/huawei/clickControl.vue"
import dingshi from "../components/oppo/ds/dingshi.vue"



import batchqdx from "../components/kehu/batchqdx.vue"
import WifiClickControl from "../components/wifi/wifiClickControl.vue"
import wifiSecretkeyConfig from "../components/wifi/wifiSecretkeyConfig.vue";
import qttZlControl from "../components/qtt/qttZlControl.vue"
import qttclickControl from "../components/qtt/clickControl.vue"
import ryclickControl from "../components/huawei/clickControl.vue"

import vivodjjc from "../components/login/vivodjjc.vue"
import dlslr from "../components/oppo/dlslr.vue"
import oppojhdj from "../components/oppo/oppojhdj.vue"
import feedbackmanager from "../components/feedbackManager/feedbackmanager.vue"
import qffeedbackmanager from "../components/feedbackManager/qffeedbackmanager.vue"
import vivoBatchEdit from "../components/vivo/BatchEdit.vue"
import BatchEditGroupName from "../components/vivo/BatchEditGroupName.vue"
import XsQrKh from "../components/vivo/XsQrKh.vue"

import vivoYYZHQuery from "../components/vivo/vivoYYZHQuery.vue"
import secondAccountQuery from "../components/vivo/secondAccountQuery.vue"
import vivoAdReportQuery from "../components/vivo/vivoAdReportQuery.vue"


import vivopdaac from "../components/vivo/vivopda/account.vue"

import vivopdaacpd from "../components/vivo/vivopda/index.vue"
import vivoBatchUpload from "../components/vivo/batchUpload.vue"


import oppopida from "../components/oppo/oppopida.vue"

import oppoaccunt from "../components/oppo/oppoaccunt.vue"
import BatchEditAdvertiserName from "../components/oppo/BatchEditAdvertiserName.vue"
import quickAppquery from "../components/login/quickAppquery.vue"
import reportform from "../components/vivo/reportform.vue"
import CjhcClickControl from "../components/cjhc/CjhcClickControl.vue";
import ZfbLink from "../components/zfb/ZfbLink.vue";
import HonorClickControl from "../components/honor/HonorClickControl.vue";


import hwReport from "../components/huawei/hwReport.vue";
import CustomerRecords from "../components/kehu/CustomerRecords.vue";
import imgtourl from "../components/imgtourl.vue";
import pqpjcontrol from "../components/piaoquan/pqpjcontrol.vue";


import creativeinfo from "../components/vivo/creativeinfo.vue"
import RedirectControl from "../components/redirect/RedirectControl.vue";
import FuJianData from "../components/login/fujiandata.vue"
import ZhangjieData from "../components/oppo/data/ZhangjieData.vue"
import JiaqiData from "../components/oppo/data/JiaqiData.vue"
import chData from "../components/oppo/data/chData.vue"
import yudiandianBatchAddAccount from "../components/yudiandian/batchAddAccount.vue"
import ksBudget from "../components/ks/ksBudget.vue"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/reportform',
      name: 'reportform',
      component: reportform
    },{
      path: '/quickAppquery',
      name: 'quickAppquery',
      component: quickAppquery
    },
    {
      path: '/selectime',
      name: 'selectime',
      component: selectime
    },{
      path: '/oppopida',
      name: 'oppopida',
      component: oppopida
    },{
      path: '/oppoaccunt',
      name: 'oppoaccunt',
      component: oppoaccunt
    },{
      path: '/oppo/batchEditAdvertiserName',
      name: 'batchEditAdvertiserName',
      component: BatchEditAdvertiserName
    },
    {
      path: '/creativeinfo',
      name: 'creativeinfo',
      component: creativeinfo
    },{
      path: '/hwReport',
      name: 'hwReport',
      component: hwReport
    },
    {
      path: '/vivodjjc',
      name: 'vivodjjc',
      component: vivodjjc
    },
    {
      path: '/dlslr',
      name: 'dlslr',
      component: dlslr
    },
    {
      path: '/feedbackmanager',
      name: 'feedbackmanager',
      component: feedbackmanager
    },

    {
      path: '/qffeedbackmanager',
      name: 'qffeedbackmanager',
      component: qffeedbackmanager
    },
    {
      path: '/oppojhdj',
      name: 'oppojhdj',
      component: oppojhdj
    },
    {
      path: '/customerRecords',
      name: 'CustomerRecords',
      component: CustomerRecords,

    },
    {
      path: '/smqudao',
      name: 'smqudao',
      component: smqudao
    },
    {
      path: '/OppoCkDashboard',
      name: 'OppoCkDashboard',
      component: OppoCkDashboard
    },
    {
      path: '/qutotiaopida',
      name: 'qutotiaopida',
      component: qutotiaopida
    },
    {
      path: '/qdxqdhcj',
      name: 'qdxqdhcj',
      component: qdxqdhcj
    },
    {
      path: '/qtttoken',
      name: 'qtttoken',
      component: qtttoken
    },
    {
      path: '/directpkg',
      name: 'directpkg',
      component: directpkg
    },
    {
      path: '/yzm',
      name: 'yzm',
      component: yzm
    },
    {
      path: '/zhzqian',
      name: 'zhzqian',
      component: zhzqian
    },
    {
      path: '/quttzh',
      name: 'quttzh',
      component: quttzh
    },
    {
      path: '/qttclickControl',
      name: 'qttclickControl',
      component: qttclickControl
    },
    {
      path: '/ryclickControl',
      name: 'ryclickControl',
      component: ryclickControl
    },
    {
      path: '/qttdxb',
      name: 'qttdxb',
      component: qttdxb
    },
    {
    path: '/vivopidaces',
    name: 'vivopidaces',
    component: vivopidaces
    },
    {
      path: '/newvivopidaces',
      name: 'newvivopidaces',
      component: newvivopidaces
    },
    {
      path: '/dingshi',
      name: 'dingshi',
      component: dingshi
    },
    {
      path: '/statusquery',
      name: 'statusquery',
      component: statusquery
    },
    {
      path: '/audience',
      name: 'audience',
      component: audience
    },
    {
      path: '/jus',
      name: 'jus',
      component: jus
    }, {
      path: '/Ophuanxing',
      name: 'Ophuanxing',
      component: Ophuanxing
    },
    {
      path: '/huomiao',
      name: 'huomiao',
      component: huomiao
    },
    {
      path: '/sucaiku',
      name: 'sucaiku',
      component: sucaiku
    }, {
      path: '/modou',
      name: 'modou',
      component: modou
    },
    {
      path: '/feiyu',
      name: 'feiyu',
      component: feiyu
    },
    {
      path: '/xindyy',
      name: 'xindyy',
      component: xindyy
    },
    {
      path: '/vivoplsb',
      name: 'vivoplsb',
      component: vivoplsb
    }, {
      path: '/qdx',
      name: 'qdx',
      component: qdx
    }, {
      path: '/fufei02',
      name: 'fufei02',
      component: fufei02
    },
    {
      path: '/fufei01',
      name: 'fufei01',
      component: fufei01
    },
    {
      path: '/daiyunying',
      name: 'daiyunying',
      component: daiyunying
    },
    {
      path: '/volzh',
      name: 'volzh',
      component: volzh
    },
    {
      path: '/tytest',
      name: 'tytest',
      component: tytest
    },
    {
      path: '/oppo/piliangdajianmf',
      name: 'oppldjmf',
      component: oppldjmf
    },
    {
      path: '/cidgelei',
      name: 'cidgelei',
      component: cidgelei
    },
    {
      path: '/shyb',
      name: 'shyb',
      component: shyb
    },
    {
      path: '/cidbb',
      name: 'cidbb',
      component: cidbb
    },
    {
      path: '/fxinfanhua',
      name: 'fxinfanhua',
      component: fxinfanhua
    },
    // {
    //   path: '/vivoXinPiDa',
    //   name: 'vivoXinPiDa',
    //   component: vivoXinPiDa
    // },
    // {
    //   path: '/vquickpida',
    //   name: 'vquickpida',
    //   component: vquickpida
    // },
    {
      path: '/chpida',
      name: 'chpida',
      component: chpida
    },
    // {
    //   path: '/vquickpidaces',
    //   name: 'vquickpidaces',
    //   component: vquickpidaces
    // },
    {
      path: '/oppoAll',
      name: 'oppoAll',
      component: oppoAll
    },
    {
      path: '/oppofujianAll',
      name: 'oppofujianAll',
      component: oppofujianAll
    },

    {
      path: '/szAllData',
      name: 'szAllData',
      component: szAllData
    },


    {
      path: '/dyy',
      name: 'dyy',
      component: dyy
    },
    {
      path: '/peixun',
      name: 'peixun',
      component: peixun
    },
    {
      path: '/cid',
      name: 'cidbatch',
      component: cidbatch
    },
    {
      path: '/changdu',
      name: 'changdu',
      component: zuikan
    }, {
      path: '/sanqibatch',
      name: 'sanqibathc',
      component: sanqibathc
    },
    {
      path: '/oppo/fengqi',
      name: 'fengqi',
      component: fengqi
    }, {
      path: '/oppo/cid',
      name: 'Cidcaimac',
      component: Cidcaimac
    },


    {
      path: '/oppo/drpkg',
      name: 'drpkg',
      component: drpkg
    },
    {
      path: '/oppo/getApi',
      name: 'getApi',
      component: getApi
    },
    {
      path: '/qjwf',
      name: 'qjwf',
      component: qjwf
    },
    {

      path: '/stop',
      name: 'planStop',
      component: planStop
    },
    {
      path: '/state',
      name: 'batchState.vue',
      component: batchState
    },
    {
      path: '/qiqi',
      name: 'qiqi',
      component: qiqi
    }, {
      path: '/feimao',
      name: 'feimao',
      component: feimao
    }, {
      path: '/dtareafeimao',
      name: 'dtareafeimao',
      component: dtareafeimao
    }, {
      path: '/qingmu',
      name: 'qingmu',
      component: qingmu
    }, {
      path: '/zhuishu',
      name: 'zhuishu',
      component: zhuishu
    }, {
      path: '/misu',
      name: 'misu',
      component: misu
    },
    {
      path: '/shengmi',
      name: 'shengmi',
      component: shengmi
    }, {
      path: '/guagua',
      name: 'guagua',
      component: guagua
    }, {
      path: '/hutao',
      name: 'hutao',
      component: hutao
    },
    {
      path: '/ywd',
      name: 'ywd',
      component: ywd
    },
    {
      path: '/code',
      name: 'code',
      component: code
    },
    {
      path: '/yikan',
      name: 'yikan',
      component: yikai
    },

    {
      path: '/user',
      name: 'vivoUserInfo',
      component: vivoUserInfo
    },
    {
      path: '/batchCode',
      name: 'BatchUpdateCode',
      component: BatchUpdateCode
    },
    {
      path: '/chumo',
      name: 'chomo',
      component: chomo
    },
    {
      path: '/batcYhk',
      name: 'batcYhk',
      component: batchYhk
    },
    {
      path: '/batchhx',
      name: 'batchhx',
      component: batchhx
    },
    {
      path: '/szh',
      name: 'szh',
      component: szh
    },
    {
      path: '/llks',
      name: 'llks',
      component: llks
    },
    {
      path: '/batchmt',
      name: 'batchmt',
      component: batchmt
    },
    {
      path: '/hx',
      name: 'huanxing',
      component: huanxing
    },
    {
      path: '/hnwc',
      name: 'wcaidemo',
      component: wcaidemo
    },
    {
      path: '/jycs',
      name: 'jycs',
      component: jycs
    },
    {
      path: '/zjcs',
      name: 'suanming',
      component: suanming
    },
    {
      path: '/zjsukan',
      name: 'zhangyue',
      component: zhangyue
    },
    {
      path: '/gg220802',
      name: 'Gg',
      component: Gg
    }, {
      path: '/dGFuZ3Rhbmc=',
      name: 'tangtang',
      component: tangtang
    }
    , {
      path: '/eGlhb3FpbmcK',
      name: 'xiaoqing',
      component: xiaoqing
    }, {
      path: '/emVu',
      name: 'zen',
      component: zen
    }, {
      path: '/amlhcWk=',
      name: 'jiaqi',
      component: jiaqi
    },
    {
      path: '/DataSourse2',
      name: 'DataSourse2',
      component: DataSourse2
    },
    {
      path: '/DataSourse1',
      name: 'DataSourse1',
      component: DataSourse1
    },
    {
      path: '/DataSourse',
      name: 'DataSourse',
      component: DataSourse
    }, {
      path: '/U2FsdGV',
      name: 'xiaoqiu',
      component: xiaoqiu
    },
    {
      path: '/gelei',
      name: 'gelei',
      component: gelei
    },
    {
      path: '/meijiezz',
      name: 'meijiezz',
      component: meijiezz
    },
    {
      path: '/test1',
      name: 'test1',
      component: test1
    }, {
      path: '/xiaoshuo01',
      name: 'xiaobai',
      component: xiaobai
    }, {
      path: '/zjqukan',
      name: 'zjqukan',
      component: zjqukan
    }, {
      path: '/sl',
      name: 'sl',
      component: sl
    },

    {
      path: '/jzdj',
      name: 'jiuzhou',
      component: jiuzhou
    },
    {
      path: '/test',
      name: 'test',
      component: test
    }, {
      path: '/time',
      name: 'time',
      component: time
    }, {
      path: '/demo',
      name: 'demo',
      component: demo
    }, {
      path: '/bxm',
      name: 'bxm',
      component: bxm
    },
    {
      path: '/woshitangtang',
      name: 'woshitangtang',
      component: woshitangtang
    }, {
      path: '/wei',
      name: 'wei',
      component: wei
    },
    {
      path: '/yq',
      name: 'xq',
      component: xq

    },
    {
      path: '/update',
      name: 'update',
      component: update
    }, {
      path: '/oppo/wacai',
      name: 'oppo',
      component: oppo
    },
    {
      path: '/zui',
      name: 'zui',
      component: zui
    }, {
      path: '/oppo/jz',
      name: 'oppo',
      component: oppo1
    }, {
      path: '/timeToV',
      name: 'ScheduledSendToV',
      component: ScheduledSendToV
    }, {
      path: '/1',
      name: 'zs',
      component: zs

    }, {
      path: '/fjtuia',
      name: 'fjtuia',
      component: fjtuia
    }, {
      path: '/index1',
      name: 'index1',
      component: index1
    }, {
      path: '/oppo/tui',
      name: 'tui',
      component: tui
    },
    {
      path: '/oppo/yachen',
      name: 'yachen',
      component: yachen
    }, {
      path: '/oppo/jz2',
      name: 'tuia2',
      component: tuia2
    }, {
      path: '/weimiao',
      name: 'weimiao',
      component: weimiao
    }
    , {
      path: '/batchUpdate',
      name: 'vueTestUpdate',
      component: vueTestUpdate
    }
    , {
      path: '/diyu',
      name: 'diyu',
      component: diyu
    }
    , {
      path: '/batchTimeUp',
      name: 'batchUpdate',
      component: batchUpdate
    }
    , {
      path: '/list',
      name: 'list',
      component: list
    }
    ,
    {
      path: '/mianfei',
      name: 'vueTestUpdateTest',
      component: vueTestUpdateTest
    }, {
      path: '/huidu',
      name: 'huidu',
      component: huidu
    },
    {
      path: '/weichiAllDataNew',
      name: 'weichiAllDataNew',
      component: weichiAllDataNew
    },
    {
      path: '/weichiAllData',
      name: 'weichiAllData',
      component: weichiAllData
    },
    {
      path: '/zjAllData',
      name: 'zjAllData',
      component: zjAllData
    },
    {
      path: '/fujianAllData',
      name: 'fujianAllData',
      component: fujianAllData
    },
    {
      path: '/yunshang',
      name: 'yunshang',
      component: yunshang
    }, {
      path: '/2',
      name: 'TestC',
      component: TestC
    }, {
      path: '/fufei',
      name: 'SongshuUpdate',
      component: SongshuUpdate
    }, {
      path: '/hudong',
      name: 'hudong',
      component: hudong
    }, {
      path: '/fanhua',
      name: 'kuaiyingy',
      component: kuaiyingy
    }, {
      path: '/login',
      name: 'batchLogin',
      component: batchLogin

    }, {
      path: '/cs',
      name: 'cesuan',
      component: cesuan
    }, {
      path: '/haobaobao',
      name: 'haobaobao',
      component: haobaobao
    }, {
      path: '/hbb',
      name: 'hbb',
      component: hbb
    }, {
      path: '/addbatch',
      name: 'addInfoBatch',
      component: addInfoBatch
    }, {
      path: '/tk',
      name: 'talk',
      component: talk
    }, {
      path: '/oppo/xiaoshuo',
      name: 'xiaoshuo1',
      component: xiaoshuo1
    }
    , {
      path: '/wzs',
      name: 'OpBatch',
      component: OpBatch
    }, {
      path: '/quickappbiaodan',
      name: 'quickappbiaodan',
      component: quickappbiaodan
    },
    {
      path: '/oppobiaodan',
      name: 'oppobiaodan',
      component: oppobiaodan
    }
    , {
      path: '/BetaOpBatch',
      name: 'BetaOpBatch',
      component: BetaOpBatch
    }
    , {
      path: '/baijiu',
      name: 'baijiu',
      component: baijiu
    }, {
      path: '/bj',
      name: 'baijiu1',
      component: baijiu1
    }, {
      path: '/opupdate',
      name: 'oppoupdate',
      component: oppoupdate
    }, {
      path: '/opupdate102',
      name: 'UpdateOp2',
      component: UpdateOp2
    }, {
      path: '/yidian',
      name: 'yidian',
      component: yidian

    }, {
      path: '/oppo/tianqiao',
      name: 'tianqiao',
      component: tianqiao

    }, {
      path: '/oppo/piliangdajian',
      name: 'opBatchXS',
      component: opBatchXS
    }
    , {
      path: '/oppo/mz',
      name: 'manzheng',
      component: manzheng
    }
    , {
      path: '/oppo/zhdj',
      name: 'zhihui',
      component: zhihui
    }, {
      path: '/oppo/duanju',
      name: 'duanju',
      component: duanju
    }, {
      path: '/oppo/opzhbzf',
      name: 'opzhbzf',
      component: opzhbzf
    }
    , {
      path: '/gl',
      name: 'geleio',
      component: geleio
    },
    {
      path: '/vivoRegistration',
      name: 'vivoRegistrationList',
      component: vivoRegistrationList
    },
    {
      path: '/kehu/opsqf',
      name: 'opsqf',
      component: opsqf
    },
    {
      path: '/kehu/csmfqd',
      name: 'csmfqd',
      component: csmfqd
    },
    {
      path: '/kehu/vivoyake',
      name: 'vivoyake',
      component: vivoyake
    },
    {
      path: '/kehu/vivozy',
      name: 'vivozy',
      component: vivozy
    },
    {
      path: '/kehu/vivomanju',
      name: 'vivomanju',
      component: vivomanju
    }, {
      path: '/kehu/opaike',
      name: 'opaike',
      component: opaike
    },{
      path: '/kehu/opyabs',
      name: 'opyabs',
      component: opyabs
    },
    {
      path: '/kehu/opxly',
      name: 'opxly',
      component: opxly
    },

    {
      path: '/kehu/batchqdx',
      name: 'batchqdx',
      component: batchqdx
    },
    {
      path: '/wifi/clickControl',
      name: 'WifiClickControl',
      component: WifiClickControl
    },

    {
      path: '/wifi/secretkeyConfig',
      name: 'wifiSecretkeyConfig',
      component: wifiSecretkeyConfig
    },
    {
      path: '/qtt/qttZlControl',
      name: 'qttZlControl',
      component: qttZlControl
    },
    {
      path: '/vivo/batchEdit',
      name: 'batchEdit',
      component: vivoBatchEdit
    },
    {
      path: '/vivo/XsQrKh',
      name: 'XsQrKh',
      component: XsQrKh
    },
    {
      path: '/vivo/vivoYYZHQuery',
      name: 'vivoYYZHQuery',
      component: vivoYYZHQuery
    },
    {
      path: '/vivo/secondAccountQuery',
      name: 'secondAccountQuery',
      component: secondAccountQuery
    },
    {
      path: '/vivo/vivoAdReportQuery',
      name: 'vivoAdReportQuery',
      component: vivoAdReportQuery
    },
    {
      path: '/vivo/vivopdaacpd',
      name: 'vivopdaacpd',
      component: vivopdaacpd
  },{
    path: '/vivo/vivopdaac',
    name: 'vivopdaac',
    component: vivopdaac
  },
  {
    path: '/vivo/batchUpload',
    name: 'vivoBatchUpload',
    component: vivoBatchUpload
  },
    {
      path: '/vivo/batchEditGroupName',
      name: 'batchEditGroupName',
      component: BatchEditGroupName
    },
    {
      path: '/cjhc/CjhcClickControl',
      name: 'CjhcClickControl',
      component: CjhcClickControl
    },
    {
      path: '/honor/HonorClickControl',
      name: 'HonorClickControl',
      component: HonorClickControl
    },
    {
      path: '/zfb/ZfbLink',
      name: 'ZfbLink',
      component: ZfbLink
    },
    {
      path: '/imgtourl',
      name: 'ImgToUrl',
      component: imgtourl
    },
    {
      path: '/pqpjcontrol',
      name: 'pqpjcontrol',
      component: pqpjcontrol
    },
    {
      path: '/redirectControl',
      name: 'RedirectControl',
      component: RedirectControl
    },
    {
      path: '/fuJianData',
      name: 'FuJianData',
      component: FuJianData
    },
    {
      path: '/oppo/zhangjie',
      name: 'ZhangjieData',
      component: ZhangjieData
    },
    {
      path: '/oppo/jiaqi',
      name: 'JiaqiData',
      component: JiaqiData
    },
    {
      path: '/oppo/chData',
      name: 'chData',
      component: chData
    },
    {
      path: '/yudiandian/batchAddAccount',
      name: 'yudiandianBatchAddAccount',
      component: yudiandianBatchAddAccount
    },
    {
      path: '/ks/budget',
      name: 'ksBudget',
      component: ksBudget
    },
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js